<template>
  <div>
    <el-card class="ibox">
      <div slot="header" class="flex justify-between">
        <div>{{ $t('productSeckillOrder.queryCondition') }}</div>
      </div>
      <div class="">
        <el-form :inline="true" :model="productSeckillOrderInfo.conditions" class="flex justify-start">
          <el-form-item>
            <el-input
              :placeholder="$t('productSeckillOrder.orderIdPlaceholder')"
              v-model="productSeckillOrderInfo.conditions.orderId"
              clearable
            ></el-input>
          </el-form-item>
          <el-form-item>
            <el-input
              :placeholder="$t('productSeckillOrder.productNamePlaceholder')"
              v-model="productSeckillOrderInfo.conditions.prodName"
              clearable
            ></el-input>
          </el-form-item>
          <el-form-item>
            <el-input
              :placeholder="$t('productSeckillOrder.buyerPlaceholder')"
              v-model="productSeckillOrderInfo.conditions.buyerName"
              clearable
            ></el-input>
          </el-form-item>
          <el-form-item>
            <el-button
              type="primary"
              @click="_queryProductSeckillOrderMethod"
              icon="el-icon-search"
            >
              {{ $t('productSeckillOrder.query') }}
            </el-button>
          </el-form-item>
        </el-form>
      </div>
    </el-card>

    <el-card class="margin-top-sm">
      <div slot="header" class="flex justify-between">
        <div>{{ $t('productSeckillOrder.title') }}</div>
      </div>
      <div class="">
        <product-seckill-order-table
          :orders="productSeckillOrderInfo.orders"
          :total="productSeckillOrderInfo.total"
          :page="productSeckillOrderInfo.conditions.page"
          @page-change="handlePageChange"
        ></product-seckill-order-table>
      </div>
    </el-card>
  </div>
</template>

<script>
import { listProductSeckillOrder } from '@/api/group/productSeckillOrder/productSeckillOrderApi'
import { getShopId } from '@/api/shop/shopApi'
import ProductSeckillOrderTable from '@/components/group/productSeckillOrder/productSeckillOrderTable'

export default {
  name: 'ProductSeckillOrder',
  components: {
    ProductSeckillOrderTable
  },
  data() {
    return {
      DEFAULT_PAGE: 1,
      DEFAULT_ROWS: 10,
      productSeckillOrderInfo: {
        orders: [],
        total: 0,
        records: 1,
        conditions: {
          orderId: '',
          prodName: '',
          buyerName: '',
          state: '',
          shopId: '',
          page: 1,
          row: 10
        }
      }
    }
  },
  created() {
    this.productSeckillOrderInfo.conditions.shopId = getShopId()
    this._listProductSeckillOrders(this.DEFAULT_PAGE, this.DEFAULT_ROWS)
  },
  methods: {
    async _listProductSeckillOrders(page, rows) {
      this.productSeckillOrderInfo.conditions.page = page
      this.productSeckillOrderInfo.conditions.row = rows
      
      try {
        const res = await listProductSeckillOrder(this.productSeckillOrderInfo.conditions)
        this.productSeckillOrderInfo.total = res.total
        this.productSeckillOrderInfo.records = res.records
        this.productSeckillOrderInfo.orders = res.data
      } catch (error) {
        console.error('获取秒杀订单失败:', error)
      }
    },
    _queryProductSeckillOrderMethod() {
      this._listProductSeckillOrders(this.DEFAULT_PAGE, this.DEFAULT_ROWS)
    },
    handlePageChange(currentPage) {
      this._listProductSeckillOrders(currentPage, this.DEFAULT_ROWS)
    }
  }
}
</script>

<style scoped>
.ibox {
  margin-bottom: 20px;
}
.ibox-title {
  border-color: #e7eaec;
  border-style: solid solid none;
  border-width: 4px 0 0;
  color: inherit;
  margin-bottom: 0;
  padding: 15px 15px 7px;
  min-height: 48px;
}
.ibox-content {
  background-color: #ffffff;
  color: inherit;
  padding: 15px 20px 20px 20px;
  border-color: #e7eaec;
  border-style: solid solid none;
  border-width: 1px 0;
}
</style>